var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.13,
    y1: 171.8,
    x2: 180.9,
    y2: 32.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 16.45,
    y1: 156.96,
    x2: 167.23,
    y2: 18.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 26.83,
    y1: 168.22,
    x2: 177.6,
    y2: 29.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 37.2,
    y1: 179.48,
    x2: 187.98,
    y2: 40.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 47.57,
    y1: 190.73,
    x2: 198.35,
    y2: 51.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 57.94,
    y1: 201.99,
    x2: 208.72,
    y2: 63.07,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.35,25.24c-.12-.11-.26-.24-.42-.4,0,0-.02-.02-.02-.02l-22.82-21.76-.35-.33c-.9-.86-1.83-1.75-3.56-1.75h-94.58c-2.76,0-5.01,2.25-5.01,5.01v15.38l-33.33,5.71c-2.67.47-4.47,3.03-4.01,5.69l1.69,9.86c-10.82,3.64-21.94,7.4-32.7,11.26-2.54.93-3.87,3.75-2.96,6.3l21.36,59.38c.43,1.2,1.56,1.94,2.76,1.94.33,0,.66-.06.99-.17,1.52-.55,2.31-2.23,1.77-3.75L6.11,59.1c10.13-3.63,20.6-7.17,30.83-10.61l10.07,58.69,11.58,67.59c.42,2.39,2.52,4.08,4.88,4.08.27,0,.54-.02.81-.07l31.37-5.38,24.51-4.2-36.87,13.25-29.08,10.45-22.58-62.81c-.55-1.52-2.23-2.31-3.75-1.77-1.52.55-2.31,2.23-1.77,3.75l22.9,63.7c.45,1.23,1.35,2.22,2.54,2.77.67.32,1.38.47,2.1.47.56,0,1.13-.1,1.67-.3l29.95-10.77,68-24.44,12.99-2.23h28.7c2.76,0,5.01-2.25,5.01-5.02V28.54c0-1.75-.95-2.65-1.65-3.3ZM190.59,25.94h-15.02c-.7,0-2.35.02-2.76-.4-.1-.1-.21-.42-.21-1.01l-.03-15.79,18.03,17.19ZM77.45,155.43v-57.1c0-1.62-1.31-2.93-2.93-2.93s-2.93,1.31-2.93,2.93v57.94c0,2.77,2.25,5.02,5.01,5.02h55l-36.93,6.33-30.46,5.23-11.42-66.67-12.6-73.49,31.41-5.38v57.43c0,1.62,1.31,2.93,2.93,2.93s2.93-1.31,2.93-2.93V6.83h89.25l.04,17.71c0,2.15.65,3.88,1.94,5.16,1.98,1.96,4.77,2.1,6.51,2.1.15,0,.29,0,.42,0h18.53s0,123.64,0,123.64h-116.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.27,43.53h-83.76c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h83.76c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.27,64.35h-83.76c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h83.76c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.27,85.16h-83.76c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h83.76c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.27,105.97h-83.76c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h83.76c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.27,126.79h-83.76c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h83.76c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z"
  })));
};
export default SvgDocs;